/**
 * Login failure reasons
 */
export const LoginError = {
  NotFound: 'not-found',
  Disabled: 'disabled',
  TooManyFailedLogins: 'too-many-failed-logins',
  InvalidPassword: 'invalid-password',
  InvalidChallenge: 'invalid-challenge',
  NotAuthorized: 'not-authorized',
  Unknown: 'unknown'
}
